module.exports = __webpack_public_path__ + "img/rapheal.6c0b237b.jpg";